// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgClockIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 5a1 1 0 0 0-1 1v4a1 1 0 0 0 .504.868l3.5 2a1 1 0 1 0 .992-1.736L13 11.42V8a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
  </g>
);
export default SvgClockIcon;
SvgClockIcon.displayName = 'SvgClockIcon';
